import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import AjustesMenu from '../components/AjustesMenu'; // O '../components/AjustesMenu' según la ruta real
import { getUserFromStorage } from '../services/auth';

const BASE_URL = 'https://mundiemby.us.to';
const AVATARES_POR_PAGINA = 24;

function CrearPerfil() {
  const [nombre, setNombre] = useState('');
  const [avatar, setAvatar] = useState('default.png');
  const [esAdmin, setEsAdmin] = useState(false);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [avatares, setAvatares] = useState([]);
  const [pagina, setPagina] = useState(0);
  const navigate = useNavigate();

  

const perfilActual = JSON.parse(localStorage.getItem('perfilActual'));
const user = getUserFromStorage();
const user_id = user?.id;  // ✅ el ID del usuario logueado real





  useEffect(() => {
    fetch(`${BASE_URL}/api/avatars`)
      .then((res) => res.json())
      .then((data) => setAvatares(data))
      .catch(() => {
        setAvatares(['default.png']);
        setError('No se pudieron cargar los avatares disponibles');
      });
  }, []);

  const seleccionarAvatar = (nuevoAvatar) => {
    setAvatar(nuevoAvatar);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nombre.trim()) {
      return setError('El nombre es obligatorio');
    }

    const payload = {
      user_id,
      nombre,
      avatar,
      pin: pin || null,
      es_admin: esAdmin
    };

    console.log("✅ Payload enviado:", payload); // 👈 AÑADE ESTA LÍNEA

    try {
      await api.post('/perfiles', payload);
      navigate('/dashboard');
    } catch (err) {
      const errorMsg =
        err.response?.data?.detalle ||
        err.response?.data?.error ||
        err.message ||
        'Error desconocido';
      setError('No se pudo crear el perfil: ' + errorMsg);
    }
  };

  const handleVolver = () => {
    navigate(-1);
  };

  if (!perfilActual?.es_admin) {
    return (
      <div style={{ color: 'white', padding: '2rem' }}>
        <h2>No tienes permiso para crear perfiles.</h2>
        <button onClick={() => navigate('/dashboard')} style={styles.button}>Volver</button>
      </div>
    );
  }

  const totalPaginas = Math.ceil(avatares.length / AVATARES_POR_PAGINA);
  const avataresPagina = avatares.slice(
    pagina * AVATARES_POR_PAGINA,
    (pagina + 1) * AVATARES_POR_PAGINA
  );

  return (
    <div style={styles.container}>
      <AjustesMenu />
      <button onClick={handleVolver} style={styles.volverMejorado}>Volver</button>
      <h2>Crear nuevo perfil</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder="Ej: Niño, Invitado, etc."
          required
          style={styles.input}
        />

        <div>
          <label style={styles.label}>Selecciona tu avatar</label>

          <div style={styles.paginationButtons}>
            <button
              type="button"
              onClick={() => setPagina(p => Math.max(p - 1, 0))}
              disabled={pagina === 0}
              style={styles.pageButton}
            >
              «
            </button>
            <span style={styles.pageIndicator}>Página {pagina + 1} de {totalPaginas}</span>
            <button
              type="button"
              onClick={() => setPagina(p => Math.min(p + 1, totalPaginas - 1))}
              disabled={pagina >= totalPaginas - 1}
              style={styles.pageButton}
            >
              »
            </button>
          </div>

          <div style={styles.avatarGrid}>
            {avataresPagina.map((a) => (
              <img
                key={a}
                src={`${BASE_URL}/avatars/${a}`}
                alt={a}
                onClick={() => seleccionarAvatar(a)}
                style={{
                  ...styles.avatarMiniatura,
                  border: avatar === a ? '3px solid white' : '1px solid #333'
                }}
              />
            ))}
          </div>

          <img
            src={`${BASE_URL}/avatars/${avatar}`}
            alt="Vista previa"
            style={styles.avatarPreview}
          />
        </div>

        <input
          type="password"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          placeholder="PIN numérico"
          maxLength={10}
          style={styles.input}
        />

        <div style={{ marginTop: '1rem' }}>
          <label>
            <input
              type="checkbox"
              checked={esAdmin}
              onChange={(e) => setEsAdmin(e.target.checked)}
            />
            ¿Es administrador?
          </label>
        </div>

        {error && <p style={{ color: 'red' }}>{error}</p>}

        <button type="submit" style={styles.button}>Crear Perfil</button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    minHeight: '100vh'
  },
  volverMejorado: {
    position: 'absolute',
    top: '0.5rem',
    left: '0.5rem',
    background: '#444',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '0.3rem 0.5rem',
    fontSize: '1.3rem',
    cursor: 'pointer',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    width: 'fit-content'
  },
  form: {
    maxWidth: '650px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  input: {
    padding: '0.6rem',
    fontSize: '1.2rem',
    borderRadius: '8px',
    border: '1px solid #555',
    background: '#111',
    color: 'white',
    textAlign: 'center'
  },
  label: {
    fontSize: '1rem',
    color: 'white',
    marginBottom: '0.3rem'
  },
  avatarGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(8, 1fr)',
    gap: '10px',
    justifyItems: 'center',
    marginTop: '10px',
    marginBottom: '10px'
  },
  avatarMiniatura: {
    width: '60px',
    height: '60px',
    borderRadius: '10px',
    objectFit: 'cover',
    cursor: 'pointer'
  },
  avatarPreview: {
    marginTop: '15px',
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '10px',
    border: '2px solid white',
    alignSelf: 'center'
  },
  button: {
    padding: '0.8rem',
    background: '#444',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  paginationButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '10px'
  },
  pageButton: {
    background: '#222',
    color: 'white',
    border: '1px solid #666',
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  pageIndicator: {
    fontSize: '0.9rem',
    color: '#ccc'
  }
};

export default CrearPerfil;
